// extracted by mini-css-extract-plugin
module.exports = {"banners":"DashboardBanners_banners__37ajr"};